<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="Filtros">
            <div class="col-auto">
                <label class="col-form-label text-primary">Por</label>
            </div>

            <div class="col-auto">
                <select @change="Lista" v-model="Filtro.IdProductoCategoria" class="form-select form-control-search">
                    <option value="">Todas las categorías</option>
                    <option v-for="(item,index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
                </select>
            </div>

            <div class="col-auto">
                <select @change="Lista" v-model="Filtro.TipoMaterial" class="form-select form-control-search">
                    <option value="">Todos los tipos</option>
                    <option value="Material">Material</option>
                    <option value="Herramienta">Herramienta</option>
                    <option value="Insumo">Insumo</option>
                </select>
            </div>
        </template>

        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Nombre</th>
            <th :class="StyleTh">Categoría</th>
            <th :class="StyleTh">Stock</th>
            <th :class="StyleTh">Tipo de Material</th>
            
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                <td><p :class="StyleTd">{{lista.producto_categoria.Nombre}}</p></td>
                <td><p :class="StyleTd">{{lista.Stock}}</p></td>
                <td><p :class="StyleTd">{{lista.TipoMaterial}}</p></td>
                
                <td class="align-middle text-end">
                    <button v-if="lista.visible" @click="SeleccionarMaterial(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary"></i> Agregar</button>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
        </template>
    </CList>

</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionMaterialesSalida';

export default {
    name: 'ListaMateriales',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: '',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                BtnNewShow: false,
                TitleFirst: '',
                ShowTitleFirst: false,
                ShowFooter: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:"",
                TipoMaterial: '',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],       
            Emit: this.poBtnSave.EmitSeccion,        
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Categorias:[],
            Material:{},
            ListaAgregados: [],
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("materiales",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria: this.Filtro.IdProductoCategoria,
                    TipoMaterial: this.Filtro.TipoMaterial
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                let response = res.data.data.data;
                //this.ListaArrayRows     = 
                //this.segurity           = res.data.segurity;
                let arr = this;

                response.map(function(element){
                    let visible = true;

                    if(element.Stock == 0){
                        visible = false;
                    }
                    else
                    {
                        let filtrado = arr.ListaAgregados.filter(function(item){
                            if(element.IdMaterial == item.IdMaterial){
                                return item;
                            }
                            else{
                                return '';
                            }
                        });

                        if(filtrado[0]){
                            visible = false;
                        }
                    }

                    element.visible = visible;
                });

                this.ListaArrayRows = response;

            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        ListaCategorias(){
            this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data;
            })
        },
        SeleccionarMaterial(item)
        {
            let obj = {
                IdSolicitudAlmacenDetalle : 0,
                IdSolicitudAlmacen: 0,
                IdCotizacionEvento: 0,
                IdCotizacionEventoDetalle: 0,
                IdMaterial: item.IdMaterial,
                Nombre: item.Nombre,
                Stock: item.Stock,
                CantidadSalida: 0,
                TipoMaterial: item.TipoMaterial,

                SalidaCheck: 0,
                EntradaCheck: 0,
                CantidadEntrada: 0,
                ComentarioSalida: '',
                ComentarioEntrada: '',
            };

            this.bus.$emit('AgregarMaterialSalida',obj);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
    },
    created()
    {
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
            this.ListaAgregados = obj;

            this.ListaCategorias();
            this.Lista();

            this.bus.$off('List_'+EmitEjecuta);
            this.bus.$on('List_'+EmitEjecuta,()=>
            {
                this.Lista();
            });
        });
    },
    mounted()
    {
    }
}
</script>
